




































































































































































































































import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import { BIcon, BIconBoxArrowRight } from "bootstrap-vue";
import Pdf from "@/components/Pdf.vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
import Footer from "@/components/Footer.vue";
@Component({
  components: {
    Header,
    Menu,
    BIcon,
    BIconBoxArrowRight,
    Pdf,
    NextPrevBtn,
    Footer,
  },
})
export default class DefStrategy extends Vue {
  protected pdfDefStrat = [
    {
      PdfLink: "/pdf_OWcom/PlanCom.pdf",
      PdfDownload:
        "Pourquoi et comment concevoir son plan de communication\xa0?",
      TxtPdf: "Plan de communication",
    },
    {
      PdfLink: "/pdf_OWcom/PlanCom2.pdf",
      PdfDownload: "Le plan de communication",
      TxtPdf: "Le plan de communication",
    },
    {
      PdfLink: "/pdf_OWcom/PlanCom3.pdf",
      PdfDownload: "Etablir le plan de communication d’un projet",
      TxtPdf: "Etablir le plan de communication d’un projet",
    },
  ];
  protected nxtprevDefStrategy = {
    BoolPrev: true,
    BoolNext: false,
    PrevImage: "/thumbnail3.png",
    NextImage: "",
    PrevLink: "/Definition_Communication/Situation_Communication",
    NextLink: "",
  };
}
